const simpleNotificationPath = "/sounds/simple-notification.mp3"

const alarmAudio = new Audio(simpleNotificationPath)

export const playAlarm = (volume: number) => {
  alarmAudio.volume = volume
  alarmAudio.play()
}
